module.exports = "/images/casque.png?89f631e1acedad5571aa9f847c4a28b4";